import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './channel-actions.styl';


@VODCSSModules(styles)
export default class ChannelActions extends React.Component {

  render() {
    return (
      <div styleName="container">
        <div>
          TODO Actions
        </div>

        <button onClick={this.toggleVisibilityAllVideos}>
          TODO Close
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/channel-actions/channel-actions.js